import { createSwarmGesture } from './swarmFactory.js';
export default createSwarmGesture('right');
